import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

export const StyledText = styled.div<{ $isList?: boolean }>`
  font-size: 14px;
  font-weight: 400;
  line-height: 160%;
  letter-spacing: 0.14px;
  white-space: ${({ $isList }): string => ($isList ? 'pre' : 'nowrap')};
  overflow: hidden;
  text-overflow: ellipsis;
  width: 200%;
  display: inline-block;
`;

export const StyledCollapseButton = styled.div<{ $size: 'small' | 'medium' | 'large' }>(
  ({ theme: { admanColors }, $size }) => {
    const sizeList = {
      small: '14px',
      medium: '15px',
      large: '16px',
    };

    return css`
      font-weight: 600;
      color: ${admanColors!.blue.solid};
      font-size: ${sizeList[$size]};

      &:hover {
        cursor: pointer;
      }
    `;
  }
);
